import React, { ReactElement, useCallback, useContext, useState } from 'react';
import { Nullable } from '../../../models';
import { getSimpleEvent, logger, pushDataLayer } from '../../../services';
import { HelpContextModel, HelpProviderProps } from './helpButton.model';
import {
  CommonEvents,
  CommonEventTypes,
  getProjectEventPosition,
  UsagePositions,
} from '../../../analytics';
import { openFastLinksMenu } from '../../../catalog';
import { useDispatch } from 'react-redux';

const HelpContext = React.createContext<Nullable<HelpContextModel>>(null);

export const HelpContextProvider = ({
  children,
}: HelpProviderProps): ReactElement => {
  const dispatch = useDispatch();
  const [isPopupOpened, setIsPopupOpened] = useState<boolean>(false);

  const handleOpenPopup = useCallback((usagePosition?: UsagePositions) => {
    if (usagePosition) {
      pushDataLayer(
        getSimpleEvent(
          CommonEvents.clickButtonAskQuestion,
          CommonEventTypes.overallEvents,
          getProjectEventPosition(usagePosition)
        )
      );
    }
    setIsPopupOpened(true);
    dispatch(openFastLinksMenu(false));
  }, []);

  const handleClosePopup = () => {
    setIsPopupOpened(false);
  };

  const context = {
    handleOpenPopup,
    handleClosePopup,
    isPopupOpened,
  };

  return (
    <HelpContext.Provider value={context}>{children}</HelpContext.Provider>
  );
};

export const useHelpContext = (): HelpContextModel => {
  const value = useContext(HelpContext);

  if (!value) {
    logger.error(
      '[ERROR]: HelpContext: you cannot use context without a provider'
    );

    return {} as HelpContextModel;
  }

  return value;
};
